const CALENDLY_URL = "https://calendly.com/lmsdeveloperai/30min";
const CALENDLY_CSS = "https://assets.calendly.com/assets/external/widget.css";
const CALENDLY_JS = "https://assets.calendly.com/assets/external/widget.js";

let loadingPromise;

// Load Calendly's widget script and styles once, on first use.
const loadCalendly = () => {
  if (window.Calendly) return Promise.resolve();
  if (loadingPromise) return loadingPromise;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CALENDLY_CSS;
  document.head.appendChild(link);

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = CALENDLY_JS;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => {
      loadingPromise = undefined;
      reject();
    };
    document.body.appendChild(script);
  });
  return loadingPromise;
};

export const openCalendly = () => {
  loadCalendly()
    .then(() => window.Calendly.initPopupWidget({ url: CALENDLY_URL }))
    // If the script can't load (e.g. blocked), open the booking page directly.
    .catch(() => window.open(CALENDLY_URL, "_blank", "noopener,noreferrer"));
};
